import { FiltersType, ListingRequest } from '@/api/types';
import { client } from '@/client';
import { Group } from '@/client/groups';
import { LazyLoadingMultiselect } from '@/components/form/generic/LazyLoadingMultiselect';
import { useAppSelector } from '@/hooks/store';
import { selectCurrentAccount } from '@/store/features/account';
import React, { HTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

type GroupsMultiselectInputProps = {
  onChange: (value: Group[]) => void;
  onBlur?: () => void;
  additionalFilters?: FiltersType;
  selectedOptions?: Group[];
  isDisabled?: boolean;
  accountId?: string;
} & Omit<HTMLAttributes<HTMLSelectElement>, 'onChange'>;

export const GroupsMultiselectInput: React.FC<GroupsMultiselectInputProps> = ({
  onChange,
  onBlur,
  className,
  additionalFilters,
  selectedOptions,
  isDisabled,
  accountId,
}) => {
  const { t } = useTranslation();
  const currentAccount = useAppSelector(selectCurrentAccount);
  const fetchGroups = isDisabled
    ? undefined
    : async (params: ListingRequest) =>
        await client.groups.getGroups(params, accountId || currentAccount?.id);

  return (
    <LazyLoadingMultiselect
      fetchService={fetchGroups}
      filter
      display="chip"
      optionLabel="name"
      placeholder={t('group.select')}
      maxSelectedItems={3}
      additionalFilters={additionalFilters}
      selectedValues={selectedOptions || []}
      className={className}
      handleOnChange={onChange}
      onBlur={onBlur}
      isDisabled={isDisabled}
    />
  );
};
